module.exports = __webpack_public_path__ + "img/hdd-stack-fill.b075745e.svg";